(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .directive('percentMask', ['$filter', percentMask]);

    function percentMask($filter) {
        var directive = {
            require: 'ngModel',
            scope: {
                min: '&min',
                max: '&max'
            },
            link: link
        };

        return directive;

        function link(scope, element, attrs, ngModelController) {
            ngModelController.$parsers.push(function(data) {
                if (typeof data !== 'string') {
                    return null;
                }

                var min = scope.min();
                var max = scope.max();

                data = data.replace(/[^0-9.\-]/g, '').replace(/[.](?=.*[.])/g, '');

                var numberValue = data.length === 0 || isNaN(data) ? null : parseFloat(data);

                if (numberValue !== null) {
                    if (typeof min === 'number') numberValue = Math.max(min, numberValue);
                    if (typeof max === 'number') numberValue = Math.min(max, numberValue);
                }
                return numberValue;
            });

            ngModelController.$formatters.push(function(data) {
                return percentFormatter(data);
            });

            element.on('blur', function() {
                ngModelController.$viewValue = percentFormatter(ngModelController.$modelValue);
                ngModelController.$render();
            });

            function percentFormatter(value) {
                if (value == null || isNaN(value)) return '';
                return $filter('number')(value, 2) + '%';
            }
        }
    }
})();
